import api from "../api";
import { useAuthSessionStore } from "../stores/authSession";
import { logError } from "../helpers/logError";

// Single switch entry point used by the top-bar profile menu and SwitchOrganizationDialog.
// UI side-effects (top bar org name updating, redirect from detail pages) ride on
// useAuthSessionStore + useOrgRouteGuard.
export function useOrgSwitch() {
	async function switchOrganization(organizationId: string): Promise<boolean> {
		if (!organizationId) {
			return false;
		}
		const session = useAuthSessionStore();
		if (session.organizationId === organizationId) {
			return true;
		}
		try {
			// EXPLICIT: this composable backs the organization switcher and
			// SwitchOrganizationDialog — the user picked the organization, so the switch must never
			// be silently dropped by the bfcache-restore latch. Caught by
			// tests/unit/authRedirectClassificationGuard.spec.ts as the SIXTH forgotten call site
			// on this PR, which is exactly what that guard exists for (LSP-17342).
			await api.setOrganizationId(organizationId, { isExplicitUserIntent: true });
			return true;
		} catch (err) {
			logError("useOrgSwitch: setOrganizationId failed", err, { organizationId });
			return false;
		}
	}

	return {
		switchOrganization
	};
}
